// lazyload
jQuery(function($) {
  // var _pcFlag = false;
  var _prgWidth;
  var _prgHeight;
  // var _winWidth = $(window).width();
  // var _winHeight = $(window).height();
  // if (_winWidth > _winHeight) {
  //   _pcFlag = true;
  // }
  // キービジュアルの画像など
  // var $kv = $('#js-kv');
  // var $kvTitle = $('#js-kv-title');
  // var $kvTitleItem = $kvTitle.find('.s-intro-visual__txt');
  if ($('#js-loading').length) {
    $('#js-loading').imagesLoaded(function(){
      // bodyの画像数を取得
      var imgNum = imagesLoaded('body', {background: true}).images.length;
      // 読み込んだ画像の数を格納
      var loadedImg = 0;
      // 現在のプログレス値を格納
      var progressNowPosition = 0;
      // 1秒間に50回、progressMonitor()を実行する
      Timer = setInterval(progressMonitor, 1000 / 50);
      // ローディング解除関数
      function clearLoadWindow() {
        clearInterval(Timer);
        $('#js-loading').addClass('is-hidden');
        $('#js-body').addClass('is-show');
        // if ($kv.length) {
        //   $kv.addClass('is-show');
        // }
        // if ($kvTitle.length) {
        //   $kvTitle.addClass('is-show');
        // }
      }
      // 画像を読み込んだらloadedImgを加算する
      imagesLoaded('body', {background: true}).on('progress', function() {
        loadedImg++;
      });

      // 画像の読み込み状況をチェックし、更新する関数
      function progressMonitor() {
        // 読み込んだ画像のパーセンテージ
        var progressPosition = (loadedImg / imgNum) * 100;
        // プログレス値を現在値と目標値からイージングする
        progressNowPosition += (progressPosition - progressNowPosition) * 0.1;
        // プログレスバーの横幅を指定する
        $('#js-progress').css('height', progressNowPosition + '%');
        // _prgHeight = $('#js-progress').width();
        // if (_pcFlag) {
        //   $('#js-progress').css('width', progressNowPosition + '%');
        //   _prgWidth = $('#js-progress').width();
        //   $('#js-progress').css('height', _prgWidth + 'px');
        // } else {
        //   $('#js-progress').css('height', progressNowPosition + '%');
        //   _prgHeight = $('#js-progress').height();
        //   $('#js-progress').css('width', _prgHeight + 'px');
        // }

        // 読み込んだ画像のパーセンテージ数値を表示する
        // $('#progressTxt').text(Math.floor(progressNowPosition) + '%');

        // 読み込みが完了した場合の処理
        if (progressNowPosition >= 100) {
          clearLoadWindow();
        }

        // イージング計算を完了させる
        if (progressNowPosition > 99.9) {
          progressNowPosition = 100 + 10;
        }

      }

    });
  }
});
